module.exports = __webpack_public_path__ + "img/B6.9176e451.png";